import React from 'react';
import { Row, Typography, Col } from 'antd';

import classnames from 'classnames';

import './ProductThumbFooter.less';

const { Text } = Typography;

const ProductThumbFooter = React.memo((props) => {
  const { upc, sku, rivirId } = props;

  return (
    <div className='pd-thumb-foot'>
      <Row style={{ width: '100%' }}>
        <Col xs={24} className='pd-thumb-foot__content'>
          <Text className='pd-thumb-foot__label' strong>
            UPC:
          </Text>
          <Text className='pd-thumb-foot__text' ellipsis={true}>
            {upc || 'N/A'}
          </Text>
        </Col>
        <Col xs={24} className='pd-thumb-foot__content'>
          <Text className='pd-thumb-foot__label' strong>
            SKU:
          </Text>
          <Text className='pd-thumb-foot__text' ellipsis={true}>
            {sku || 'N/A'}
          </Text>
        </Col>
      </Row>
    </div>
  );
});

export default ProductThumbFooter;
